//import
import AppModulesLoader from "./app-modules-loader";
import navVertical from "../../front/views/navigation/";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";

// Navigation toggle
window.addEventListener("load", function () {
  AppModulesLoader();
  navVertical();
  lazyLoadElements();

  if (document.querySelector("#primary-menu")) {
    let main_navigation = document.querySelector("#primary-menu");
    document
      .querySelector("#primary-menu-toggle")
      .addEventListener("click", function (e) {
        e.preventDefault();
        document.querySelector('#primary-menu-toggle').classList.toggle("active");
        document.querySelector('.header').classList.toggle("active");
        main_navigation.classList.toggle("mobile-hidden");
      });
  }

  window.addEventListener("scroll", () => {
    if (window.scrollY > 80 && !document.body.classList.contains("scrolled")) {
      document.body.classList.add("scrolled");
    } else if (
      window.scrollY <= 80 &&
      document.body.classList.contains("scrolled")
    ) {
      document.body.classList.remove("scrolled");
    }
  });
  function lazyLoadElements(){
    gsap.registerPlugin(ScrollTrigger)
  
    const lazyVideos = gsap.utils.toArray('.lazyElement');
    
    lazyVideos.forEach((lazy, i) => {
      ScrollTrigger.create({
        trigger: lazy,
        once: true,
        onEnter: () => {
          const dataSrc = lazy.getAttribute('data-src');
          if (dataSrc) {
            lazy.src = dataSrc;
          }
        },
      });
    });
  }
});
